export const MAGIC_DATA_STORAGE_KEY = 'cirkayMagic'

export const FAN_PASS_SESSION_STORAGE_KEY = 'storedSessions'